import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

const AlertDialog = (props) => (
  <Dialog open={props.open} onClose={props.handleClose}>
    <DialogTitle sx={{ pl: "10px" }}>Delete Confirmation</DialogTitle>
    <Divider />
    <DialogContent
      sx={{
        background: "#111",
        padding: "8px 10px !important",
        minWidth:400
      }}
    >
      <DialogContentText id="alert-dialog-description">
        {props.message}
      </DialogContentText>
    </DialogContent>
    <Divider />
    <DialogActions>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          width: "100%",
        }}
      >
        <Button
          variant="outlined"
          onClick={props.handleClose}
          color="primary"
          size="large"
          startIcon={<ClearIcon />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={props.handleDelete}
          color="secondary"
          size="large"
          startIcon={<SaveIcon />}
        >
          Delete
        </Button>
      </Stack>
    </DialogActions>
  </Dialog>
);

export default AlertDialog;
